import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoutImg from '../assets/images/refresh.png';

const Header = () => {
  const [useremail, setUserEmail] = useState('');
  useEffect(() => {
    const gmuserItem = localStorage.getItem('_gm_usr');
    const gmuser = gmuserItem ? JSON.parse(gmuserItem) : false;

    if (gmuser) {
      setUserEmail((value) => gmuser.gmUsrEmail);
    }
  }, []);
  return (
    <header className='dashboardHeader'>
      <div className='navbarRight dash'>
        {/* <p className='headerInfo'>An even more powerful software <a id="" href="https://www.friender.io/pre-sale-notification" target="_blank">FRIENDER</a> is coming soon. Click <a id="" href="https://www.friender.io/pre-sale-notification" target="_blank">HERE</a> for more information</p> */}
        <div className='profileInfo dashboardPages'>
          <div className='profilImage'>
            {/* <img src={core} alt='headerImg' /> */}
          </div>
          <div className='informations'>
            <span className='profileGreetings'>Welcome</span>
            <span className='profileName'>{useremail}</span>
          </div>
          <div className='logoutSection'>
            <Link
              to='/#'
              className='logoutTag'
              onClick={(e) => {
                e.preventDefault();
                window.localStorage.clear();
                window.location.reload();
              }}
            >
              <img className='logoutImg' src={logoutImg} alt='' />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
